import React from "react"; 
import { Link } from "react-router-dom";    
import BrandsListContent from "../../../components/Dashboard/BrandsListContent";

const BrandsList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>List of Brands</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>eCommerce</li>
          <li>Brands List</li>
        </ul>
      </div> */}

<BrandsListContent/>
    </>
  );
};

export default BrandsList;
